import * as React from "react"

import { cn } from "../../lib/utils"
import { fieldControlClassName } from "./input"

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        fieldControlClassName,
        "h-auto min-h-24 resize-y py-2 leading-relaxed placeholder:text-muted-foreground",
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
Textarea.displayName = "Textarea"

export { Textarea }
